export const FEATURE_SWITCHES = {
  SOCIAL_UPGRADE: 'social-upgrade',
  ELASTICSEARCH: 'use-elasticsearch',
  DISABLE_ANALYTICS: 'disable-analytics',
  ROLE_BASED_DASHBOARDS: 'simple-bib',
  EMBED_CARD_WHITELABEL: 'embed-card-whitelabel',
  EMBED_CARD_VIEW: 'embed-card-view',
  EMBED_CARD_PUBLIC_WHITELABEL: 'embed-card-public-white-label',
  EMBED_CARD_PUBLIC_WHITELABEL_HEADER: 'embed-card-public-whitelabel-header',
  NOBUZZ: 'nobuzz',
  MW_INTERSTITIAL: 'mw-interstitial',
  DOMOAPPS_DOMAIN_WHITELIST: 'domoapps-domain-whitelist',
  SPARK_EMAIL: 'spark-email',
  ADD_FILTER_TYPE: 'add-filter-type',
};
